import { Action, createReducer, on } from "@ngrx/store";
import * as WarehouseActionTypes from "../../actions/warehouse/warehouse.actions";

export interface WarehousesState {
  warehousesBySite: any;
  warehouses: any;
  isLoading: boolean;
  error: Error;
}

export const initialState: WarehousesState = {
  warehouses: null,
  isLoading: false,
  error: null,
  warehousesBySite: null,
};

const warehouseReducer = createReducer(
  initialState,
  on(
    WarehouseActionTypes.getTankListBySite,
    (state, { siteCode }) =>
      ({
        ...state,
        error: null,
        siteCode: siteCode,
        isLoading: true,
      } as WarehousesState)
  ),
  on(WarehouseActionTypes.loadTankListBySite, (state, { response }) => {
    return {
      ...state,
      warehousesBySite: (response as any).result?.items
        ? (response as any).result?.items
        : undefined,
      isLoading: false,
      error: null,
    };
  })
);

export function reducer(state: WarehousesState | undefined, action: Action) {
  return warehouseReducer(state, action);
}
